import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constants } from '../constants/url.constants';

@Injectable()
export class StartupService {
  // tslint:disable-next-line:variable-name
  private _startupData: any;
  BASE_URL = environment.baseUrl;
  userData$: Observable<any>;
  showErrorPage: boolean;

  constructor(
    private http: HttpClient
  ) { }
  
  // This is the method you want to call at bootstrap
  // Important: It should return a Promise

  async load(): Promise<any> {
    const body = 'client_id=trusted_client&grant_type=client_credentials&client_secret=secret';
    let dataHeadersOfSpartacus = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    this.userData$ = this.http.post(this.BASE_URL + Constants.TOKEN, body, {
      headers: dataHeadersOfSpartacus
    });

    await this.userData$.toPromise().then(async res => {
      if (res) {
        this._startupData = res;
      }
    },
    ).catch(err => {
    this.showErrorPage = true;
    });
    return this._startupData;
}

  get startupData(): any {
    return this._startupData;
  }
  verifyToken(): any {
   return  this.http.post(this.BASE_URL + Constants.verifyToken(),'',{withCredentials: true})
  }

}
